import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LanguageService } from 'src/app/services/language.service';
import { IdentityService } from 'src/app/@core/services/identity.service';
import { LanguageEnum } from 'src/app/shared/models/item.model';
import { PageType } from '../enums/page-type.enum';
import { PageModel } from '../model/page.model';
import { PagesService } from '../service/pages.service';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss'],
})
export class AboutUsComponent implements OnInit, OnDestroy {
  isRtl: boolean = true;
  /** CMS "about" page (Settings › pages, type AboutUs). Null until loaded / when none is published. */
  cmsPage: PageModel | null = null;
  cmsContent: SafeHtml | null = null;
  private destroySubject: Subject<void> = new Subject();

  constructor(private languageService: LanguageService,
    private pagesService: PagesService,
    private sanitizer: DomSanitizer,
    private identityService: IdentityService) { }

  get isUnified(): boolean {
    return this.identityService.isUnifiedCode();
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.isRtl = this.languageService.getCurrentLanguage() === LanguageEnum.ar;
    this.languageService.languageChange
      .pipe(takeUntil(this.destroySubject))
      .subscribe((result: LanguageEnum) => {
        this.isRtl = result === LanguageEnum.ar;
        this.setCmsContent();
      });
    this.loadCmsPage();
  }

  /** E2E-ISSUE-111: show the CMS about page when the admin published one, otherwise the built-in copy. */
  loadCmsPage(): void {
    this.pagesService.getPage(PageType.AboutUs)
      .pipe(takeUntil(this.destroySubject))
      .subscribe({
        next: (result: PageModel) => {
          this.cmsPage = result ?? null;
          this.setCmsContent();
        },
        error: () => {
          this.cmsPage = null;
          this.cmsContent = null;
        },
      });
  }

  private setCmsContent(): void {
    const page = this.cmsPage;
    const body = page
      ? (this.isRtl ? (page.contentAr || page.content) : (page.content || page.contentAr))
      : null;
    this.cmsContent = body && body.trim().length > 0 ? this.sanitizer.bypassSecurityTrustHtml(body) : null;
  }

  get cmsTitle(): string {
    if (!this.cmsPage) return '';
    return (this.isRtl ? (this.cmsPage.titleAr || this.cmsPage.title) : (this.cmsPage.title || this.cmsPage.titleAr)) || '';
  }

  ngOnDestroy(): void {
    this.destroySubject.next();
  }
}
